import { type FC } from "react";
import { Check } from "lucide-react";
import { FLOWS } from "./types";
 
interface StepIndicatorProps {
  currentIndex: number;
  onStepClick: (index: number) => void;
}
 
const StepIndicator: FC<StepIndicatorProps> = ({ currentIndex, onStepClick }) => (
  <div className="mb-8 flex items-center">
    {FLOWS.map((task, idx) => {
      const isCompleted = idx < currentIndex;
      const isCurrent = idx === currentIndex;
      const isLast = idx === FLOWS.length - 1;
      return (
        <div
          key={task.id}
          className={`flex items-center ${isLast ? "" : "flex-1"}`}
        >
          <div 
            className="flex flex-col items-center gap-2 cursor-pointer"
            onClick={() => onStepClick(idx)}
          >
            <div
              className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full gx-p12-b transition-colors ${
                isCompleted
                  ? "bg-black text-white"
                  : isCurrent
                    ? "bg-black text-white ring-4 ring-gray-200"
                    : "bg-gray-100 text-gray-400 border border-gray-300"
              }`}
            >
              {isCompleted ? <Check className="h-4 w-4" /> : idx + 1}
            </div>
            <span
              className={`gx-p10-m whitespace-nowrap ${
                isCurrent
                  ? "text-gray-900"
                  : isCompleted
                    ? "text-gray-600"
                    : "text-gray-400"
              }`}
            >
              {task.shortLabel}
            </span>
          </div>
          {!isLast && (
            <div
              className={`mx-3 h-0.5 flex-1 rounded-full transition-colors ${
                isCompleted ? "bg-black" : "bg-gray-200"
              }`}
              style={{ marginBottom: "1.25rem" }}
            />
          )}
        </div>
      );
    })}
  </div>
);
 
export default StepIndicator;
